import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PreDefinedSlotBookingResponse, PreDefinedSlotDao } from '../db-models/pre-defined-slot-dao';
import { PreDefinedSlotServiceCategoryGroup } from '../db-models/pre-defined-slot-service-dao';
import { resendPaidBookingWhileLocked } from './booking-outcome.util';
import { TimezoneService } from './timezone.service';

@Injectable({
  providedIn: 'root'
})
export class PreDefinedSlotService {

  private http = inject(HttpClient);
  private timezoneService = inject(TimezoneService);

  /**
   * Fetch available services for pre-defined slots, grouped by category.
   */
  getAvailableServices(): Observable<PreDefinedSlotServiceCategoryGroup[]> {
    return this.http.get<PreDefinedSlotServiceCategoryGroup[]>(
      environment.apiUrl + 'pre-defined-slots/services'
    );
  }

  /**
   * Fetch available pre-defined slots (future only).
   */
  getAvailableSlots(serviceUuid?: string): Observable<PreDefinedSlotDao[]> {
    return this.http.post<PreDefinedSlotDao[]>(
      environment.apiUrl + 'pre-defined-slots',
      {
        service_uuid: serviceUuid || null,
        timezone: this.timezoneService.getLocalTimezone(),
      }
    );
  }

  /**
   * Book a pre-defined slot by its UUID.
   * Sets customer_id on the appointment and marks is_bookable_in_widget=false.
   */
  bookSlot(slotUuid: string, customerData: Record<string, any>): Observable<PreDefinedSlotBookingResponse> {
    return this.http.post<PreDefinedSlotBookingResponse>(
      environment.apiUrl + 'pre-defined-slots/' + slotUuid + '/book',
      customerData
    ).pipe(resendPaidBookingWhileLocked(!!customerData?.adyen_session_id));
  }
}
